/*
 This file contains Global helper functions which are used through out application
 */


export function checkNull(myval)
{
  return (myval != null);
}